var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.321 16.6668H4.67933C4.30933 16.6668 3.99266 16.5349 3.72933 16.271C3.466 16.0071 3.33405 15.6907 3.3335 15.3218V4.67933C3.3335 4.30933 3.46544 3.99266 3.72933 3.72933C3.99322 3.466 4.30988 3.33405 4.67933 3.3335H15.321C15.691 3.3335 16.0077 3.46544 16.271 3.72933C16.5343 3.99322 16.6663 4.30988 16.6668 4.67933V15.321C16.6668 15.691 16.5349 16.0077 16.271 16.271C16.0071 16.5343 15.6904 16.6663 15.321 16.6668ZM15.1927 13.8785H4.80766V15.3843H15.1927V13.8785ZM4.80766 13.141H15.1927V11.6343H4.80766V13.141ZM4.80766 10.7052H15.1927V4.8085H4.80766V10.7052Z",
    fill: "#2A4365",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPost);
export default __webpack_public_path__ + "static/media/post.b3d8856ee2db92934599e09eaf702e5a.svg";
export { ForwardRef as ReactComponent };